import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Logger } from '@core/interfaces/Logger';
import { NetworkConnectionService } from '@core/services/network-connection/network-connection.service';
import { ServiceStateService } from '@features/service/application/services/service-state.service';

@Injectable({ providedIn: 'root' })
export class DrawerStatusService {
  private readonly networkConnectionService = inject(NetworkConnectionService);
  private readonly serviceStateService = inject(ServiceStateService);
  private readonly logger = inject(Logger);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.listenNetworkConnection();
  }

  private checkDrawerStatus(): void {
    const currentDrawer = this.serviceStateService.getCurrentDrawer();
    const drawers = this.serviceStateService.getAllDrawers();

    if (!currentDrawer || !drawers?.length) {
      return;
    }

    const hasCurrentDrawer = drawers.some(
      (drawer) => drawer.id === currentDrawer.id
    );

    if (!hasCurrentDrawer) {
      this.logger.error(
        new Error('Current drawer not found locally, clearing selection')
      );
      this.serviceStateService.removeCurrentDrawer();
    }
  }

  private listenNetworkConnection(): void {
    this.networkConnectionService.onNetworkConnectionChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isInternetConnected: boolean) => {
        if (isInternetConnected) {
          this.checkDrawerStatus();
        }
      });
  }
}

